import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sidebar } from '../moderator/Sidebar';
import { Navbar } from '../../components/Navbar';
import config from "../../config/config";

export default function AddSupplier() {
  const [animalType, setAnimalType] = useState([]);
  const [subCat, setSubcat] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    supp_name: "",
    cnic: "",
    contact: "",
    address: "",
    ageed_amt: "",
    cat_id: "",
    sub_cat_id: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = { 'Authorization': `Bearer ${token}` };

        const [catRes, subRes] = await Promise.all([
          fetch(`${config.baseUrl}/api/subcategories/animal-type`, { headers }),
          fetch(`${config.baseUrl}/api/subcategories/subcat`, { headers })
        ]);

        setAnimalType(await catRes.json());
        setSubcat(await subRes.json());
      } catch (error) {
        console.error("Fetch failed", error);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.supp_name) newErrors.supp_name = "Required";
    if (formData.cnic?.length !== 13) newErrors.cnic = "Must be 13 digits";
    if (!formData.cat_id) newErrors.cat_id = "Select a category";
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const payload = {
        ...formData,
        cat_id: parseInt(formData.cat_id, 10),
        sub_cat_id: parseInt(formData.sub_cat_id, 10),
      };

      const response = await fetch(`${config.baseUrl}/api/supplierDetails/addSupplier`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        navigate("/SuperAdminDashboard/supplierDetails");
      } else {
        const data = await response.json();
        alert(data.message || "Submission failed");
      }
    } catch (err) {
      alert("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (      
        <main className="flex justify-center">
          <div className="w-full max-w-2xl bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="bg-indigo-800 p-6">
              <h2 className="text-xl font-bold text-white text-center">Add New Supplier</h2>
            </div>

            <form onSubmit={handleSubmit} className="p-8 space-y-5">
              {/* Grid Layout for compact look */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                
                {/* Name */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Supplier Name</label>
                  <input
                    type="text"
                    name="supp_name"
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition ${errors.supp_name ? 'border-red-500 bg-red-50' : 'border-gray-200'}`}
                    placeholder="John Doe"
                  />
                  {errors.supp_name && <span className="text-xs text-red-500 mt-1">{errors.supp_name}</span>}
                </div>

                {/* CNIC */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">CNIC (13 Digits)</label>
                  <input
                    type="text"
                    name="cnic"
                    maxLength="13"
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="35201..."
                  />
                </div>

                {/* Contact */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Contact</label>
                  <input
                    type="text"
                    name="contact"
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="03XXXXXXXXX"
                  />
                </div>

                {/* Amount */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Agreed Amount</label>
                  <div className="relative">
                    <span className="absolute left-3 top-2 text-gray-400">Rs.</span>
                    <input
                      type="number"
                      name="ageed_amt"
                      onChange={handleInputChange}
                      className="w-full pl-12 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                  </div>
                </div>

                {/* Category Selection */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Category</label>
                  <select
                    name="cat_id"
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  >
                    <option value="">Select Category</option>
                    {animalType.map((type) => (
                      <option key={type.id} value={type.id}>{type.cat_name}</option>
                    ))}
                  </select>
                </div>

                {/* Filtered Sub Category Selection */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Sub Category</label>
                  <select
                    name="sub_cat_id"
                    onChange={handleInputChange}
                    disabled={!formData.cat_id}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none disabled:bg-gray-50"
                  >
                    <option value="">Select Sub Category</option>
                    {subCat
                      .map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>

                {/* Address */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Address</label>
                  <textarea
                    name="address"
                    rows="2"
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="Full street address..."
                  />
                </div>
              </div>

              <div className="flex items-center justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="px-6 py-2 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-8 py-2 bg-indigo-800 text-white font-bold rounded-lg hover:bg-indigo-700 shadow-md shadow-blue-200 transition disabled:opacity-50"
                >
                  {loading ? "Processing..." : "Save Supplier"}
                </button>
              </div>
            </form>
          </div>
        </main>
   
  );
}